import { Component, OnInit } from '@angular/core';
import { AudioCourse, Course, Reads } from '../../models/course';
import { ApiService } from '../../lib/api.service';
import { ModalService } from '../../lib/modal.service';
import { LogService } from '../../lib/log.service';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'admin-course-listing',
    templateUrl: 'admin-course-listing.component.html',
    styleUrls: ['./admin-course-listing.component.scss'],
    standalone: false,
})
export class AdminCourseListingPage implements OnInit {
    isLoaded: boolean = false;
    courses: Course[] = [];
    audioCourses: AudioCourse[] = [];
    storyList: any[] = [];
    burningQuestionList: any[] = [];
    dailyList: any[] = [];
    readsList: any[] = [];
    dailyGroups: any = [];
    cols: any = [];
    selectedGroupId: number;
    filterDailycontent: any[];
    seriesPageType: string;
    selectedTabIndex: number = 0;
    selectedSubTabIndex: number = 0;
    private lastLoadKey: string | null = null;
    public constructor(
        private api: ApiService,
        private modalService: ModalService,
        private logService: LogService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.cols.push('');
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(data => {
            if (data.type) {
                this.seriesPageType = data.type;
            }
            // this.getCourseList();
            // this.getStoryList();
            // this.getBurningList();
            // this.getGroupDropdown();
        });
    }

    getGroupDropdown() {
        this.isLoaded = false;
        this.api.get('series/dailyseries/getgroups').subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result) {
                    if (result.length != 0) {
                        this.dailyGroups = result;
                        this.selectedGroupId = this.dailyGroups[0].ID;
                        this.getDailyList(this.selectedGroupId);
                    } else {
                        this.dailyList = [];
                        this.dailyGroups = [];
                    }
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }
    getCourseList() {
        this.courses = [];
        let payLoad = { list: 'all' };
        if (this.seriesPageType == 'customType') {
            payLoad['CourseType'] = 'organization';
        }
        this.api.get('series/serieslisting', payLoad).subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result.data) {
                    const resCourses = result.data;
                    for (var key in resCourses) {
                        this.courses.push(
                            new Course({
                                id: resCourses[key].ID,
                                label: resCourses[key].Label,
                                key: resCourses[key].Key,
                                active: resCourses[key].Active,
                            })
                            // new Course(resCourses[key])
                        );
                    }
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }
    getStoryList() {
        this.storyList = [];
        let payLoad = {};
        if (this.seriesPageType == 'customType') {
            payLoad['CourseType'] = 'organization';
        }
        this.api.get('series/adminstories', payLoad).subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result) {
                    if (result.length != 0) {
                        const resCourses = result;
                        for (var key in resCourses) {
                            this.storyList.push(
                                new AudioCourse({
                                    id: resCourses[key].ID,
                                    titleen: resCourses[key].Title_en,
                                    authoren: resCourses[key].Author_en,
                                    active: resCourses[key].Active,
                                    category:
                                        this.seriesPageType != 'customType'
                                            ? resCourses[key]?.categorydetails
                                                  ?.Title || ''
                                            : '',
                                })
                            );
                        }
                    } else {
                        this.storyList = [];
                    }
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }
    getBurningList() {
        this.burningQuestionList = [];
        let payLoad = {};
        if (this.seriesPageType == 'customType') {
            payLoad['CourseType'] = 'organization';
        }
        this.api.get('series/adminburningquestions', payLoad).subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result) {
                    if (result.length != 0) {
                        const resCourses = result;
                        for (var key in resCourses) {
                            this.burningQuestionList.push(
                                new AudioCourse({
                                    id: resCourses[key].ID,
                                    titleen: resCourses[key].Title_en,
                                    authoren: resCourses[key].Author_en,
                                    active: resCourses[key].Active,
                                    category:
                                        this.seriesPageType != 'customType'
                                            ? resCourses[key]?.categorydetails
                                                  ?.Title || ''
                                            : '',
                                })
                            );
                        }
                    } else {
                        this.burningQuestionList = [];
                    }
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }
    getDailyList(id) {
        this.dailyList = [];
        this.api.get('admin/series/dailyseries?group=' + id).subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result) {
                    const resCourses = result;
                    for (var key in resCourses) {
                        this.dailyList.push(
                            new AudioCourse({
                                id: resCourses[key].ID,
                                category_id: resCourses[key].CategoryID,
                                category_title:
                                    resCourses[key]?.category?.Title ?? '',
                                quote_en: resCourses[key].QuoteEn,
                                quote_es: resCourses[key].QuoteEs,
                                quote_fr: resCourses[key].QuoteFr,
                            })
                        );
                    }
                    this.filterDailycontent = this.dailyList;
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }

    getReadsList() {
        this.readsList = [];
        let payLoad = {};
        if (this.seriesPageType == 'customType') {
            payLoad['CourseType'] = 'organization';
        } else {
            payLoad['CourseType'] = 'global';
        }
        this.api.get('series/adminreads', payLoad).subscribe(
            (result: any) => {
                this.isLoaded = true;
                if (result) {
                    if (result.length != 0) {
                        const resCourses = result;
                        for (var key in resCourses) {
                            this.readsList.push(
                                new Reads({
                                    id: resCourses[key].ID,
                                    titleen: resCourses[key].Title_en,
                                    active: resCourses[key].Active,
                                    category:
                                        this.seriesPageType != 'customType'
                                            ? resCourses[key].categorydetails
                                                  ?.Title || ''
                                            : '',
                                })
                            );
                        }
                    } else {
                        this.readsList = [];
                    }
                }
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug('Error getting series. ' + error.message);
                this.isLoaded = true;
            }
        );
    }

    onMainTabChange(index: number) {
        this.selectedTabIndex = index;
        this.loadActiveTab();
    }

    onSubTabChange(subIndex: number) {
        this.selectedSubTabIndex = subIndex ?? 0;
        if (this.selectedTabIndex === 1) {
            this.loadActiveTab();
        }
    }

    loadActiveTab(force = false) {
        const key = `${this.selectedTabIndex}-${this.selectedSubTabIndex}`;
        if (!force && key === this.lastLoadKey) return;
        this.lastLoadKey = key;
        this.isLoaded = false;

        switch (this.selectedTabIndex) {
            case 0:
                this.getCourseList();
                break;
            case 1:
                this.selectedSubTabIndex === 0
                    ? this.getStoryList()
                    : this.getBurningList();
                break;
            case 2:
                this.seriesPageType !== 'customType'
                    ? this.getGroupDropdown()
                    : this.getReadsList();
                break;
            case 3:
                this.getReadsList();
                break;
        }
    }

    doAdd(series) {
        this.router.navigate([
            '/admin/daily-series-add/' + this.selectedGroupId,
        ]);
    }

    onGroupChange() {
        this.isLoaded = false;
        this.getDailyList(this.selectedGroupId);
    }

    filterValue(i) {
        let filterValue = this.cols[i].toLowerCase();
        let empty = this.reset();

        let key = '';
        if (i == 0) {
            key = 'categorytitle';
        } else {
            return;
        }

        if (!empty) {
            let cols = this.cols;
            let resp = _.filter(this.filterDailycontent, o => {
                const val = o[key];
                return (
                    typeof val === 'string' &&
                    val.toLowerCase().includes(filterValue)
                );
            });
            this.dailyList = resp;
        } else {
            this.dailyList = this.filterDailycontent;
        }
    }

    reset() {
        for (let i = 0; i < this.cols.length; i++) {
            if (this.cols[i] !== '') {
                return false;
            }
        }
        return true;
    }

    doCreate(type) {
        if (type === 'video') {
            this.router.navigate(['/admin/video-series/new'], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'stories') {
            this.router.navigate(['/admin/story/new'], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'burningquestion') {
            this.router.navigate(['/admin/burning-question/new'], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'daily') {
            this.router.navigate(['/admin/daily-series/import']);
        } else if (type === 'reads') {
            this.router.navigate(['/admin/reads/new'], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        }
    }

    onEdit(id, type) {
        if (type === 'video') {
            this.router.navigate(['/admin/video-series/' + id], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'stories') {
            this.router.navigate(['/admin/story/' + id], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'burningquestion') {
            this.router.navigate(['/admin/burning-question/' + id], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        } else if (type === 'daily') {
            this.router.navigate(['/admin/daily-series/' + id]);
        } else if (type === 'reads') {
            this.router.navigate(['/admin/reads/' + id], {
                queryParams: { seriesPageType: this.seriesPageType },
            });
        }
    }

    goToVideoSeries(series) {
        if (this.seriesPageType == 'customType') {
            this.router.navigate([
                '/app/series/org-series-contents/video/' + series.key,
            ]);
        } else {
            this.router.navigate(['/app/series-listing/' + series.key]);
        }
    }

    voiceRoute(type, id) {
        if (this.seriesPageType == 'customType') {
            this.router.navigate([
                '/app/series/org-series-contents/voices/' + type + '/' + id,
            ]);
        } else {
            this.router.navigate(['/app/series/voices/' + type + '/' + id]);
        }
    }
}
